@if (gallery(); as gallery) {
  <app-drop (onFileDrop)="uploadVersion($event)" [hoverStyle]="'replace'" [disable]="!galleryPermissions().can_edit">
    <div class="drop-holder"></div>
    @if (platformBrowser && active) {
      <div
        class="all-container"
        [style.--color-primary]="gallery.primary_color"
        (mouseup)="mouseUp($event)"
        (mousemove)="mouseMove($event)"
        (contextmenu)="onRightClick($event)"
      >
        <div
          class="section"
          [style.background-color]="theme().asset_page.background_color"
          [class.dark]="theme().asset_page.background_color === 'black'"
          [class.with-gradient]="active.asset.type === 'image' || active.asset.type === 'document'"
          (wheel)="onWheel($event)"
          (contextmenu)="onContextMenu($event)"
          [class.shrink]="sideMenuOpen"
          [class.drawing]="createAnnotation?.drawing || false"
          [class.show-top-gradient]="
            active.scale > 0.9 && (controlsVisible || annotationMode) && !mobileAnnotationViewingMode
          "
          [class.show-bottom-gradient]="
            active.scale > 0.9 &&
            (controlsVisible || annotationMode) &&
            allowedAndEnabledFeedbackOptions().length &&
            !mobileAnnotationViewingMode
          "
          [style.--background-opacity]="backgroundOpacity"
        >
          <div
            class="section-background"
            [class.do-transitions]="!dragging && !zooming"
            [style.--asset-background-color]="theme().asset_page.background_color"
          ></div>
          @if (controlsVisible && !annotationMode && !mobileAnnotationViewingMode) {
            <app-asset-header
              class="dont-hide-controls"
              [@assetHeader]
              [gallery]="gallery"
              [activeIndex]="getActiveIndex()"
              [galleryPermissions]="galleryPermissions()"
              [sideMenuOpen]="sideMenuOpen && isDesktop"
              [asset]="active.asset"
              [previewWidth]="(active.asset.version_data.data || getDataBackup()).width * active.offsetScale"
              [thumbnailBarOpen]="showThumbnailBar"
              [clientMode]="clientMode"
              (onClose)="close()"
              (onThumbnailBarOpen)="toggleThumbnailBar($event)"
              (onShowInfo)="toggleSideMenu('info')"
              (onUpload)="afterUploadNewVersion()"
              (onDelete)="afterDelete()"
              [class.pdf-mode]="isPdf(active?.asset)"
            >
            </app-asset-header>
          }

          @if (!isDesktop && commentPlacementMode === 'place') {
            <div class="mobile-info-box">Tap to Set Position</div>
          }
          @if (!isDesktop && annotationMode && !createAnnotationShapes?.length) {
            <div class="mobile-info-box">Start Drawing</div>
          }

          <ng-container *onlyForScreens="['desktop']">
            @if (controlsVisible) {
              <div
                class="asset-viewer-controls-container dont-hide-controls"
                [@assetControls]
                [class.pdf-mode]="isPdf(active?.asset)"
              >
                @if (active.asset.type === 'image') {
                  <app-image-viewer-controls
                    [scalePercent]="getScalePercent(active)"
                    (scale)="onScale($event)"
                    [fitButton]="fitButton"
                  >
                  </app-image-viewer-controls>
                } @else if (active.asset.type === 'video') {
                  <app-video-viewer-controls [time]="videoTime"> </app-video-viewer-controls>
                } @else if (active.asset.type === 'document') {
                  <app-document-viewer-controls
                    [(page)]="activePage"
                    [totalPages]="active.asset.version_data.data?.['images']?.length"
                  >
                  </app-document-viewer-controls>
                }
              </div>
            }
          </ng-container>
          <div class="asset-viewer-container-parent" [class.pdf-mode]="isPdf(active.asset)">
            <ng-container *onlyForScreens="['desktop', 'tablet']">
              @if (controlsVisible && !annotationMode && !blockNavigation && assets.length > 1) {
                <div class="arrow arrow-left dont-hide-controls" [@arrowLeft] (click)="switchAsset(-1)">
                  <app-svg src="/assets/icons/special/arrow-left.svg"></app-svg>
                </div>
              }
            </ng-container>
            @if (active.asset.type === 'image' || active.asset.type === 'document') {
              <app-image-viewer
                [asset]="active.asset"
                [noAnimation]="dragging || zooming"
                [offsetX]="active.offset.x + containerOffset / active.scale"
                [offsetY]="active._offsetY"
                [scale]="active.scale"
                [offsetScale]="active.offsetScale"
                [sideMenuOpen]="sideMenuOpen"
                [pdfMode]="isPdf(active.asset)"
                [activePage]="activePage()"
                [isDesktop]="isDesktop"
                [showWebGl]="showWebGl"
                (onImageLoaded)="onWebGlAssetLoaded()"
              ></app-image-viewer>
            }
            <div
              class="asset-viewer-container"
              [style.left]="containerleft + _containerOffset + 'px'"
              [class.do-animate]="!noContainerAnimation"
              [class.dragging]="dragging"
              [class.can-zoom]="canZoom"
              [class.place-comment-mode]="commentPlacementMode"
              [class.zoomed-in]="active.scale > 1"
              (mousedown)="mouseDown($event)"
              (touchstart)="touchStart($event)"
              (touchend)="touchEnd($event)"
              (touchmove)="touchMove($event)"
            >
              @for (data of assetDatas; track data.asset.id) {
                <div
                  [style.width]="container.width + 'px'"
                  class="asset-container"
                  [class.active]="data.asset.id === active.asset.id"
                  #assetContainer
                >
                  @if (data.active) {
                    <div
                      class="asset-container-inner"
                      [class.do-transitions]="!dragging && !zooming && !noContainerAnimation"
                      [class.hidden]="showWebGl && webglLoaded"
                    >
                      @if (showLoadingIndicator()) {
                        <app-loading-indicator color="white" class="asset-loading-indicator" size="small">
                        </app-loading-indicator>
                      }
                      @if (data.asset | canDisplayAsset) {
                        @let assetSrc =
                          data.asset.version_data
                            | assetVersionUrl
                              : data.asset.version_data.uuid
                              : data.asset.version_data.status
                              : data.asset.version_data.watermark_uuid
                              : calcAssetDisplayWidth(data)
                              : false
                              : data.asset.watermark_enabled
                              : false
                              : true
                              : false
                              : true
                              : (data === active ? activePage() : 0);
                        @if (data.asset.type === 'image') {
                          <div
                            class="asset"
                            [class.with-png-tile]="
                              (data.asset.version_data.asset_name | assetSupportsTransparency) && controlsVisible
                            "
                            [style.--offset-x]="data.offset.x + 'px'"
                            [style.--offset-y]="data._offsetY + 'px'"
                            [style.width]="data.crop.width + 'px'"
                            [style.height]="data.crop.height + 'px'"
                          >
                            <img
                              id="{{ data.asset.id }}"
                              [src]="assetSrc"
                              draggable="false"
                              (load)="data === active && imageLoaded()"
                              alt=""
                            />
                          </div>
                        } @else if (data.asset.type === 'document') {
                          <div
                            class="asset"
                            [class.with-png-tile]="
                              (data.asset.version_data.asset_name | assetSupportsTransparency) && controlsVisible
                            "
                            [style.--offset-x]="data.offset.x + 'px'"
                            [style.--offset-y]="data._offsetY + 'px'"
                            [style.width]="data.crop.width + 'px'"
                            [style.height]="data.crop.height + 'px'"
                          >
                            @for (image of data.asset.version_data.data?.['images']; track image.key) {
                              @let pageSource =
                                data.asset.version_data
                                  | assetVersionUrl
                                    : data.asset.version_data.uuid
                                    : data.asset.version_data.status
                                    : data.asset.version_data.watermark_uuid
                                    : calcAssetDisplayWidth(data)
                                    : false
                                    : data.asset.watermark_enabled
                                    : false
                                    : true
                                    : false
                                    : true
                                    : (data === active ? $index : 0);
                              @if (activePage() === $index) {
                                <img
                                  id="{{ data.asset.id }}"
                                  [src]="pageSource"
                                  draggable="false"
                                  (load)="data === active && imageLoaded()"
                                  alt=""
                                />
                              }
                            }
                          </div>
                        } @else if (data.asset.type === 'video') {
                          <app-video-viewer
                            [commentService]="commentService"
                            [class.disable-pointer-events]="commentPlacementMode"
                            [isFocused]="videoFocused"
                            (click)="videoFocused = true"
                            appClickOutside
                            (onClickOutside)="data.asset.id === active.asset.id && (videoFocused = false)"
                            class="asset"
                            [videoData]="$any(data.asset.version_data.data)"
                            [assetVersion]="data.asset.version_data"
                            [asset]="data.asset"
                            [galleryPermissions]="galleryPermissions()"
                            [isTeamMember]="isTeamMember()"
                            [gallery]="gallery"
                            [uuid]="data.asset.version_data.uuid"
                            [origin]="data.asset.version_data.asset_name"
                            [scale]="data.scale"
                            [poster]="assetSrc"
                            [active]="(!isDesktop || autoplayOnLoad()) && data.asset.id === active.asset.id"
                            [activateOnClick]="true"
                            [reportTimeChange]="data.asset.id === active.asset.id"
                            [targetWidth]="container.width"
                            [showUi]="controlsVisible && !annotationMode && !commentPlacementMode"
                            [autoplay]="autoplayOnLoad() && data.asset.id === active.asset.id"
                            [handleUi]="true"
                            [handleKeyboardShortcuts]="data.asset.id === active.asset.id && !annotationMode"
                            [style.--offset-x]="data.offset.x + 'px'"
                            [style.--offset-y]="data._offsetY + 'px'"
                            [style.width]="data.crop.width + 'px'"
                            [style.height]="data.crop.height + 'px'"
                            [selectedThreadId]="selectedThreadId"
                            [showResolved]="showResolved"
                            (onTimeChange)="onTimeChange($event)"
                            (selectThread)="selectThreadFromFace($event)"
                          ></app-video-viewer>
                        }
                      } @else {
                        <app-non-preview-file
                          [asset]="data.asset"
                          [gallery]="gallery"
                          [showSizeAndDownload]="true"
                          [style.--offset-x]="data.offset.x + 'px'"
                          [style.--offset-y]="data._offsetY + 'px'"
                          [style.width]="'100%'"
                          [style.height]="'calc(100% - 140px)'"
                          class="asset"
                          id="{{ data.asset.id }}"
                        ></app-non-preview-file>
                      }
                    </div>
                    @if (theme().asset_page.ambient_mode && data.asset.type === 'image') {
                      <img
                        class="ambience"
                        [@blurhash]
                        [src]="data.asset.version_data.data?.['exif']?.blurHash | blurHash"
                        draggable="false"
                        alt=""
                      />
                    }
                  }
                </div>
              }
            </div>
            <ng-container *onlyForScreens="['desktop', 'tablet']">
              @if (controlsVisible && !annotationMode && !blockNavigation && assets.length > 1) {
                <div
                  class="arrow arrow-right dont-hide-controls"
                  [@arrowRight]
                  (click)="switchAsset(1)"
                  data-test-id="arrow-right"
                >
                  <app-svg src="/assets/icons/special/arrow-right.svg"></app-svg>
                </div>
              }
            </ng-container>
          </div>
          @if (isPdf(active.asset)) {
            <app-pdf-page-list
              [version]="active.asset.version_data"
              [asset]="active.asset"
              [activePage]="activePage()"
              (switchPage)="activePage.set($event)"
            ></app-pdf-page-list>
          }
          @if (active.asset.type === 'image') {
            <app-image-viewer-preview
              [class.disable-pointer-events]="commentPlacementMode"
              [class.pdf-mode]="isPdf(active.asset)"
              [asset]="active.asset"
              [container]="container"
              [activePage]="activePage()"
              [showPreview]="active.scale > 1 && controlsVisible"
              [noAnimation]="dragging || zooming"
              [scale]="active.scale"
              [offsetX]="active.offset.x"
              [offsetY]="active.offset.y"
              (onPreviewMove)="onPreviewMove($event)"
              *onlyForScreens="['desktop', 'tablet']"
            ></app-image-viewer-preview>
          }
          @if (showCreateCommentOverlay) {
            <app-create-comment-overlay
              [gallery]="gallery"
              [asset]="active.asset"
              [galleryPermissions]="galleryPermissions()"
              [isTeamMember]="isTeamMember()"
              [annotationMode]="annotationMode"
              [createAnnotationShapes]="createAnnotationShapes"
              [videoTime]="videoTime"
              [position]="createCommentOverlayPosition"
              [pdfMode]="isPdf(active.asset)"
              [activePage]="activePage()"
              [commentMessage]="commentMessage"
              [isDesktop]="isDesktop"
              [commentPlacePosition]="commentPlacePosition"
              [commentPlaceAlignment]="commentPlaceAlignment"
              [isDesktop]="isDesktop"
              [offsetX]="active.offset.x"
              [offsetY]="active._offsetY"
              [scale]="active.scale"
              [offsetScale]="active.offsetScale"
              [sideMenuOpen]="sideMenuOpen"
              (toggleAnnotationMode)="toggleAnnotationMode()"
              (onNewThread)="onNewThread($event)"
              (customPosition)="commentPlacePosition = $event"
              (onClose)="createCommentOverlayClose()"
            ></app-create-comment-overlay>
          }
          @if (commentPlaceStartPosition && commentPlaceHoverRect) {
            <div
              class="overlay-drag-preview"
              [style.left]="commentPlaceHoverRect.x + 'px'"
              [style.top]="commentPlaceHoverRect.y + 'px'"
              [style.width]="commentPlaceHoverRect.width + 'px'"
              [style.height]="commentPlaceHoverRect.height + 'px'"
            ></div>
          }

          @if (
            galleryPermissions()?.can_review_if_authenticated &&
            (controlsVisible || selectedThreadId) &&
            !annotationMode
          ) {
            @if (active.asset.type !== 'video' || activeVideoViewer?.status !== 'playing') {
              <app-asset-comment-faces
                [asset]="active.asset"
                [gallery]="gallery"
                [isDesktop]="isDesktop"
                [offsetX]="active.offset.x"
                [offsetY]="active._offsetY"
                [scale]="active.scale"
                [offsetScale]="active.offsetScale"
                [sideMenuOpen]="sideMenuOpen"
                [selectedThreadId]="selectedThreadId"
                [showResolved]="showResolved"
                [hoverThreadId]="hoverThreadId"
                [transitionPosition]="!dragging && !zooming && !noContainerAnimation"
                [containerOffset]="_containerOffset"
                [videoTime]="videoTime"
                [galleryPermissions]="galleryPermissions()"
                [isTeamMember]="isTeamMember()"
                [pdfMode]="isPdf(active.asset)"
                [activePage]="activePage()"
                (selectThread)="selectThreadFromFace($event)"
                (threadHover)="hoverThreadId = $event?.id"
              ></app-asset-comment-faces>
            }
          }

          @if (annotationMode) {
            <app-create-annotation
              [offsetX]="active.offset.x"
              [offsetY]="active._offsetY"
              [scale]="active.scale"
              [offsetScale]="active.offsetScale"
              [sideMenuOpen]="sideMenuOpen"
              [isDesktop]="isDesktop"
              [showAnnotationControls]="showAnnotationControls"
              [asset]="active.asset"
              [currentColor]="annotationColor"
              [currentTool]="annotationTool"
              [pdfMode]="isPdf(active.asset)"
              [noAnimate]="dragging || zooming"
              (shapesChange)="annotationShapesChanges($event)"
              (annotationMouseDown)="annotationMouseDown()"
              (mousedown)="mouseDown($event)"
              (touchstart)="touchStart($event)"
              (touchend)="touchEnd($event)"
              (touchmove)="touchMove($event)"
              #createAnnotation
            >
            </app-create-annotation>
          }
          @if (annotationBeingViewed) {
            <app-view-annotation
              [shapes]="annotationBeingViewed.shapes"
              [sideMenuOpen]="sideMenuOpen"
              [pdfMode]="isPdf(active.asset)"
              [hideClose]="sideMenuOpen"
              [isDesktop]="isDesktop"
              [asset]="active.asset"
              [scale]="active.scale"
              [offsetX]="active.offset.x"
              [offsetY]="active._offsetY"
              [offsetScale]="active.offsetScale"
              [noAnimate]="dragging || zooming"
              [faded]="annotationMode"
              (onClose)="viewAnnotation(undefined)"
            >
            </app-view-annotation>
          }
          @if (controlsVisible && !annotationMode && !mobileAnnotationViewingMode) {
            <div class="asset-footer dont-hide-controls" [class.pdf-mode]="isPdf(active?.asset)" [@assetFooter]>
              <app-asset-page-footer
                [asset]="active.asset"
                [gallery]="gallery"
                [galleryPermissions]="galleryPermissions()"
                [sideMenuOpen]="sideMenuOpen && isDesktop"
                [currentLabel]="currentLabel()"
                [colorLabels]="colorLabels()"
                [commentPlacementMode]="!!commentPlacementMode"
                [clientMode]="clientMode"
                (onToggleLike)="toggleLike()"
                (toggleCommentPlacementMode)="toggleCommentPlacementMode()"
                (onUpdateColorLabel)="updateColorLabel($event)"
                (onUpdateAssetStatus)="updateAssetStatus($event)"
                (onStartAnnotation)="startAnnotation()"
              >
              </app-asset-page-footer>
            </div>
          }
          @if (showAnnotationControls) {
            <app-annotation-controls
              [canUndo]="!!createAnnotation?.shapes.length"
              [canRedo]="!!createAnnotation?.deletedShapes.length"
              [isDesktop]="isDesktop"
              (onSwitchTool)="annotationTool = $event"
              (onSwitchColor)="annotationColor = $event"
              (onHistoryChange)="createAnnotation.changeHistory($event)"
              (onClose)="annotationDone($event)"
              [@animationMode]
            >
            </app-annotation-controls>
          }
          @if (
            !controlsVisible &&
            !annotationMode &&
            !mobileAnnotationViewingMode &&
            !(!isDesktop && sideMenuOpen) &&
            (!commentPlacementMode || isDesktop)
          ) {
            <app-asset-feedback-hints
              [@assetFeedbackHints]
              [is_liked]="active.asset['is_liked']"
              [likes]="active.asset.likes"
              [status]="active.asset.status"
              [color_label]="active.asset.color_label"
              [commentThreadCount]="commentThreadCount$ | async"
              [gallery]="gallery"
              [galleryPermissions]="galleryPermissions()"
            >
            </app-asset-feedback-hints>
          }
        </div>
        @if (sideMenuOpen) {
          <app-asset-side-menu
            [gallery]="gallery"
            [asset]="active.asset"
            [clientMode]="clientMode"
            [mode]="sideMenuMode"
            [thumbnailBarOpen]="showThumbnailBar"
            [galleryPermissions]="galleryPermissions()"
            [isDesktop]="isDesktop"
            (onClose)="toggleSideMenu(null)"
            (onThumbnailBarOpen)="toggleThumbnailBar($event)"
            (onModeChange)="toggleSideMenu($event)"
          >
            @if (sideMenuMode === 'activity') {
              <app-comments
                #comments
                [gallery]="gallery"
                [asset]="active.asset"
                [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                [galleryPermissions]="galleryPermissions()"
                [isTeamMember]="isTeamMember()"
                [annotationMode]="annotationMode"
                [createAnnotationShapes]="createAnnotationShapes"
                [commentPlacementMode]="!!commentPlacementMode"
                [videoTime]="videoTime"
                [isDesktop]="isDesktop"
                [activePage]="activePage()"
                [hideNewCommentThread]="createAnnotationShapes?.length > 1 || showCreateCommentOverlay"
                [commentMessage]="commentMessage"
                [disableClickOutside]="disableClickOutsideThreads"
                [hoverThreadId]="hoverThreadId"
                [showResolved]="showResolved"
                (viewAnnotation)="viewAnnotation($event)"
                (videoTimeChange)="videoTimeChangeWithoutAnnotation($event)"
                (toggleAnnotationMode)="toggleAnnotationMode()"
                (onNewThread)="onNewThread($event)"
                (pageChange)="activePage.set($event)"
                (selectedThreadChange)="selectedThreadId = $event"
                (placeComment)="switchPlaceComment($event)"
                (threadHover)="hoverThreadId = $event?.id"
                (zoomToComment)="zoomToComment($event)"
                (toggleShowResolved)="showResolved = !showResolved"
              >
              </app-comments>
            }
            @if (sideMenuMode === 'info') {
              <app-asset-info [gallery]="gallery" [asset]="active.asset" [galleryPermissions]="galleryPermissions()">
              </app-asset-info>
            }
          </app-asset-side-menu>
        }
        @if (showThumbnailBar) {
          <app-thumbnail-bar
            [assets]="assets"
            [gallery]="gallery"
            [selectedAsset]="active.asset"
            (onSwitchToAsset)="onSwitchToAsset($event)"
            (onClose)="showThumbnailBar = false"
            [@thumbnailBar]
          >
          </app-thumbnail-bar>
        }
      </div>
    }
    @if (!platformBrowser) {
      <div class="all-container">
        <div
          class="section"
          [style.background-color]="theme()?.asset_page.background_color"
          [class.dark]="theme()?.asset_page.background_color === 'black'"
        >
          <div class="section-background"></div>
        </div>
      </div>
    }
  </app-drop>

  @if (active) {
    <app-ios-download-context
      [asset]="active.asset"
      [version]="active.asset.version_data"
      [galleryPermissions]="galleryPermissions()"
      [gallery]="gallery"
      [previewWidth]="(active.asset.version_data.data || getDataBackup()).width * active.offsetScale"
      (download)="download($event)"
      #iosDownloadContext
    >
    </app-ios-download-context>
  }
}

@if (showCustomMenu) {
  <div class="custom-context-menu-bg" (click)="showCustomMenu = false"></div>
  <div class="custom-context-menu" [style.left]="customMenuPos.x + 'px'" [style.top]="customMenuPos.y + 'px'">
    © {{ copyrightMessage }}
  </div>
}
